<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Seleccione sus opciones</v-toolbar-title
              >
            </v-toolbar>
            <v-container>
              <v-layout>
                <v-flex xs12 md4>
                  <v-select
                    v-model="periodoValue"
                    :items="periodoSelect"
                    label="Periodo"
                    data-vv-name="listaPeriodos"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="procesoValue"
                    :items="procesoSelect"
                    label="Proceso"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="proveedorValue"
                    :items="proveedorSelect"
                    label="Proveedor"
                    item-text="nombre"
                    item-value="code"
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs12 md4>
                  <v-select v-model="estadoValue" :items="estadoSelect" label="Estado"></v-select>
                </v-flex> -->
                <v-btn
                  fab
                  dark
                  color="teal"
                  title="Filtrar contratos"
                  @click="filterProv()"
                >
                  <v-icon dark>filter_list</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="red darken-4"
                  title="Limpiar filtros"
                  @click="clear()"
                >
                  <v-icon dark>clear_all</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Registro de contratos</v-toolbar-title
              >
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <!-- TABLA PROVEEDORES -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <div v-if="alerta">
                <alert-empty :alertaid="'proveedor'"></alert-empty>
              </div>
              <grid-proveedor
                :processIcon="true"
                :visitIcon="false"
                :relojIcon="true"
                :editIcon="true"
                :deleteIcon="true"
                :detailIcon="true"
                :itemsProveedor="itemsProveedor"
                :rowsTable="rowsTable"
              ></grid-proveedor>
            </template>
            <!-- TABLA PROVEEDORES -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import GridProveedor from "@/modules/configuration/proveedor/views/GridProveedor.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
export default {
  components: {
    GridProveedor,
    AlertEmpty,
    Loading,
  },
  props: {},
  data() {
    return {
      loading: false,
      alerta: false,
      dialog: false,
      loaded: false,
      rowsTable: [20],
      itemsProveedor: [],
      select1: null,
      periodoSelect: [],
      listaProcesos: [],
      proveedorSelect: [],
      estadoSelect: [],
      procesoSelect: [],
      procesoValue: null,
      periodoValue: null,
      estadoValue: null,
      proveedorValue: null,
      filter: false,
    };
  },
  mounted() {
    this.loadData();
    this.$store.commit("rolInContract_state", "");
  },
  created() {},
  computed: {},
  methods: {
    showAddContact() {
      this.show = true;
    },

    edit() {
      //this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: "components/usuario/edita" });
      }, 1000);
    },

    newProvider() {
      //this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: "components/proveedor-registra" });
      }, 1000);
    },

    async loadProveedoresFilter() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        proceso:
          this.procesoValue && this.procesoValue != null
            ? this.procesoValue
            : null,
        periodo:
          this.periodoValue && this.periodoValue != null
            ? this.periodoValue
            : null,
        proveedor:
          this.proveedorValue && this.proveedorValue != null
            ? this.proveedorValue
            : null,
        estado:
          this.estadoValue && this.estadoValue != null
            ? this.estadoValue
            : null,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      return await axios
        .post("/contratos/filter", this.body)
        .then(function (response) {
          // console.log("st::response:" + JSON.stringify(response, null, 2));
          return response.data;
        })
        .catch((error) => {
          // console.log("st::error home:" + JSON.stringify(error, null, 2));
          // console.log("st:userLogged:" + JSON.stringify(this.$store.getters.userLogged, null, 2));
          // console.log("fullnamer:" + this.$store.getters.userLogged.fullname);
          // console.log("contratos/filter error:" + this.$store.getters.token);
          // console.log("authStatus:" + this.$store.getters.authStatus);
          // console.log("isLoggedIn:" + this.$store.getters.isLoggedIn);
          // console.log("authStatus:" + this.$store.getters.authStatus);
          if (error) {
            console.log("st::home:" + JSON.stringify(error, null, 2));
          }
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsProveedor = await this.loadProveedoresFilter();
      if (!this.itemsProveedor || this.itemsProveedor.length == 0) {
        this.alerta = true;
        this.loading = false;
      } else {
        this.alerta = false;
        this.loading = false;
      }
      if (!this.filter) {
        this.loadProveedorSelect();
        this.loadEstadoSelect();
        this.loadProcesoSelect();
        this.loadPeriodoSelect();
      }
    },

    loadProveedorSelect() {
      let conjunto = new Set();

      // Iterar sobre los elementos y agregar solo los elementos únicos al conjunto
      if (this.itemsProveedor) {
        for (let p of this.itemsProveedor) {
          conjunto.add({
            nombre: p.proveedor.razonSocial,
            code: p.proveedor.id,
          });
        }
      }
      this.proveedorSelect = Array.from(conjunto);
    },
    loadEstadoSelect() {
      let esta = [];
      if (this.itemsProveedor) {
        this.itemsProveedor.forEach(function (p) {
          let index = esta.findIndex((x) => x.estado == p.estado);
          if (index === -1) {
            esta.push(p.estado);
          }
        });
      }
      this.estadoSelect = esta;
    },

    // Limpiar Campos
    clear() {
      //this.$v.$reset();
      this.periodoValue = "";
      this.procesoValue = "";
      this.proveedorValue = "";
      this.estadoValue = "";
      this.loadData();
    },
    close() {
      window.getApp.$emit("APP_AUTH_FAILED");
    },
    loadProcesoSelect() {
      let process = [];
      if (this.itemsProveedor) {
        this.itemsProveedor.forEach(function (p) {
          let index = process.findIndex((x) => x.proceso == p.proceso);
          if (index === -1) {
            process.push(p.proceso);
          }
        });
      }
      this.procesoSelect = process;
    },
    loadPeriodoSelect() {
      let peri = [];
      if (this.itemsProveedor) {
        this.itemsProveedor.forEach(function (p) {
          let index = peri.findIndex((x) => x.periodo == p.periodo);
          if (index === -1) {
            peri.push(p.periodo);
          }
        });
      }
      this.periodoSelect = peri;
    },
    filterProv() {
      this.filter = true;
      this.loadData();
    },
  },
};
</script>
